import Product from './Product';

export default class ProductWithSerial extends Product {
    public serialNumber: string = '';
}
